export const KHO_LIST_INITING             = 'KHO_LIST_INITING'
export const KHO_LIST_REQUESTING          = 'KHO_LIST_REQUESTING'
export const KHO_LIST_SUCCESS             = 'KHO_LIST_SUCCESS'
export const KHO_LIST_ERROR               = 'KHO_LIST_ERROR'   

export const KHO_DETAIL_INITING           = 'KHO_DETAIL_INITING'
export const KHO_DETAIL_REQUESTING        = 'KHO_DETAIL_REQUESTING'
export const KHO_DETAIL_SUCCESS           = 'KHO_DETAIL_SUCCESS'
export const KHO_DETAIL_ERROR             = 'KHO_DETAIL_ERROR'   

export const KHO_UPDATE_REQUESTING        = 'KHO_UPDATE_REQUESTING'
export const KHO_UPDATE_SUCCESS           = 'KHO_UPDATE_SUCCESS'
export const KHO_UPDATE_ERROR             = 'KHO_UPDATE_ERROR'   

export const USERS_LIST_REQUESTING          = 'USERS_LIST_REQUESTING'
export const USERS_LIST_SUCCESS             = 'USERS_LIST_SUCCESS'
export const USERS_LIST_ERROR               = 'USERS_LIST_ERROR'  

export const KHO_DETAIL_API               = '/api/v1/management/kho_detail_by_id'  
export const KHO_LIST_API                 = '/api/v1/management/kho_list_by_store'   
export const KHO_UPDATE_API               = '/api/v1/management/kho_update_by_id' 
export const USERS_LIST_API                = '/api/v1/users/get_list_by_quanly'    


// WEBPACK FOOTER //
// ./src/views/Kho/constants.js